export const top10Dapps = [
  {
    id: 1,
    title: "Uni2 Casual Game Hub",
    category: "gaming",
    impact: "50,000+ transactions/day",
    priority: "Critical",
    description: "A multi-game casual platform integrated with token rewards, leaderboards and tournament logic. Designed to generate high-frequency on-chain activity.",
    incentive: "grantRevenue",
    status: "open"
  },
  {
    id: 2,
    title: "Uni2 SocialFi Platform",
    category: "social",
    impact: "20,000+ transactions/day",
    priority: "Critical",
    description: "A decentralized social interaction layer with tipping, subscriptions and token-gated communities.",
    incentive: "revenueShare",
    status: "open"
  },
  {
    id: 3,
    title: "Uni2 DEX v3",
    category: "defi",
    impact: "Core Liquidity Engine",
    priority: "Critical",
    description: "Concentrated liquidity decentralized exchange with analytics and routing optimization.",
    incentive: "strategic",
    status: "open"
  },
  {
    id: 4,
    title: "Uni2 Money Market",
    category: "lending",
    impact: "TVL Target: $10M+",
    priority: "High",
    description: "Collateralized lending protocol for ecosystem assets.",
    incentive: "strategic",
    status: "open"
  },
  {
    id: 5,
    title: "Uni2 Pay",
    category: "payments",
    impact: "10,000+ merchants",
    priority: "High",
    description: "On-chain checkout system with QR payments and subscription module.",
    incentive: "grantRevenue",
    status: "open"
  },
  {
    id: 6,
    title: "NFT Membership & Ticketing",
    category: "nft",
    impact: "1M+ NFTs minted",
    priority: "High",
    description: "Dynamic NFT system for memberships, events and digital access control.",
    incentive: "revenueShare",
    status: "open"
  },
  {
    id: 7,
    title: "Quest & Rewards Engine",
    category: "gamification",
    impact: "100K+ users onboarded",
    priority: "High",
    description: "On-chain mission system for onboarding and ecosystem activation.",
    incentive: "grant",
    status: "open"
  },
  {
    id: 8,
    title: "Governance DAO Suite",
    category: "governance",
    impact: "Core Governance",
    priority: "Critical",
    description: "Full voting and proposal framework with delegation and treasury visibility.",
    incentive: "strategic",
    status: "open"
  },
  {
    id: 9,
    title: "Wallet Firewall & Security Layer",
    category: "security",
    impact: "All transactions protected",
    priority: "Critical",
    description: "On-chain risk detection and transaction simulation engine.",
    incentive: "strategic",
    status: "open"
  },
  {
    id: 10,
    title: "RWA Marketplace",
    category: "rwa",
    impact: "$50M+ assets tokenized",
    priority: "High",
    description: "Tokenized real estate and asset fractionalization platform with compliance-ready architecture.",
    incentive: "strategic",
    status: "open"
  }
];

export const top20Dapps = [
  { id: 11, title: "AI Agent Marketplace", category: "ai", description: "Decentralized marketplace for AI agents and models." },
  { id: 12, title: "Liquid Staking", category: "staking", description: "Liquid staking derivatives for UNI2 tokens." },
  { id: 13, title: "Payroll Crypto", category: "payroll", description: "Automated crypto payroll and invoicing system." },
  { id: 14, title: "Cross-chain Swap Hub", category: "crosschain", description: "Multi-chain swap aggregator with best rates." },
  { id: 15, title: "Data Marketplace", category: "data", description: "Decentralized data trading and monetization." },
  { id: 16, title: "Insurance Protocol", category: "insurance", description: "DeFi insurance for smart contract risks." },
  { id: 17, title: "NFT Royalty Marketplace", category: "nft", description: "Secondary market with enforced royalties." },
  { id: 18, title: "Creator Economy Tools", category: "creator", description: "Monetization tools for content creators." },
  { id: 19, title: "Loyalty Marketplace", category: "loyalty", description: "Cross-brand loyalty points exchange." },
  { id: 20, title: "Micro-payment Engine", category: "payments", description: "Sub-cent transactions for content and APIs." },
  { id: 21, title: "Oracle Marketplace", category: "oracle", description: "Decentralized oracle network for data feeds." },
  { id: 22, title: "Developer Analytics Suite", category: "analytics", description: "On-chain analytics for dApp developers." },
  { id: 23, title: "No-Code dApp Builder", category: "nocode", description: "Visual builder for smart contracts and dApps." },
  { id: 24, title: "Referral Tracking Engine", category: "analytics", description: "On-chain referral and affiliate tracking." },
  { id: 25, title: "Launchpad", category: "launchpad", description: "Token launch platform with vesting and distribution." },
  { id: 26, title: "Bridge Monitoring Dashboard", category: "bridge", description: "Real-time bridge health and security monitoring." },
  { id: 27, title: "Carbon Credit Marketplace", category: "carbon", description: "Tokenized carbon credits trading platform." },
  { id: 28, title: "Supply Chain Traceability", category: "supply", description: "Product tracking and authenticity verification." },
  { id: 29, title: "Tokenized Invoice Platform", category: "invoice", description: "Invoice factoring and financing on-chain." },
  { id: 30, title: "DAO-as-a-Service", category: "dao", description: "One-click DAO creation and management." }
];

export const allDapps = [...top10Dapps, ...top20Dapps];
